const $=jQuery;
jQuery(document).ready(function ($) {
  if ($('.page-width-custom').hasClass('b2b')) {
    const firstB2B = $('input.b2b-option[type=radio]').not(':disabled').first();
    if (firstB2B.length && !firstB2B.prop('checked')) {
      const label = $('label[for="' + firstB2B.attr('id') + '"]');
    
      if (label.length) {
          label.trigger('click');
          
        } else {
          firstB2B.prop('checked', true).trigger('change');
      }
    }
  }
  handlePreisgruppeDisplay();
  function handlePreisgruppeDisplay() {
      const $fieldset = $('.preisgruppe,.titel ,.group');
      let visibleOptions;
      if ($('.page-width-custom').hasClass('b2b')) {
        visibleOptions = $fieldset.find('label.b2b-option:not([disabled])').length;
      } else {
        visibleOptions = $fieldset.find('input.standard-option[type="radio"]:not(:disabled)').length;
      }
      if (visibleOptions <= 1) {
        $fieldset.hide();
        $(".b2b").addClass('b2b-custom-box');
      } else {
        $fieldset.show();
  }
}
$(document).on('click', '.menu-drawer summary.menu-drawer__menu-item', function (_e) {
    $('header-drawer').addClass('active');
  });
  $(document).on('click', '.menu-drawer__inner-submenu .menu-drawer__close-button', function (_e) {
$('header-drawer').removeClass('active');
  });
  
  
   $(document).on('click', '.vehicle-custom .gf-option-box li a', function (e) {
  e.preventDefault();

  const selectedType = $(this).find('.gf-label').text().trim();
  const handleizedType = selectedType.toLowerCase().replace(/\s+/g, '-');

  $('.vehicle_planner_slider').hide();
  $('.slider-' + handleizedType).show();

  console.log('Selected:', handleizedType);
});

$(document).ready(function () {
  const initialChecked = $('.vehicle-custom .gf-option-box li a.checked').first().find('.gf-label').text().trim();
  if (initialChecked) {
    const handleized = initialChecked.toLowerCase().replace(/\s+/g, '-');
    $('.slider-' + handleized).show();
  }
});


  $('.footer-block.has-dropdown h2.footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
   // Initially hide all accordions except the first 5
  $(".everything_sec .accordion:gt(4)").addClass("hidden");

  $(".everything_sec .show-more-btn").on("click", function () {
    if ($(".everything_sec .accordion.hidden").length > 0) {
      $(".everything_sec .accordion.hidden").removeClass("hidden");
      $(this).hide();
    }
  });

  $(".icon-with-text-box h4 span.svg-wrapper").on("click", function() {
    $(this).closest(".icon-with-text-box").addClass("hide-text-box");
  }); 
  $(".color-option").on("click", function() {
      const src = $(this).attr("src");
      if (src) {
         $('.custom-img-click').attr('srcset', '');
         $(this).closest('.card-wrapper').find('.custom-img-click2').attr('srcset', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click').attr('srcset', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click2').attr('src', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click').attr('src', src);  
      }
    }); 
  
    setTimeout(function() { 
        $('.list-payment').css('opacity','1');
    }, 100);
    $('.select__select').on('change', function() {
        const selectedValue = $(this).val(); 
        const formAttribute = $(this).attr('form');
        $('#' + formAttribute).find('.product-variant-id').val(selectedValue);
    });
});

 class PriceRange1 extends HTMLElement {
    connectedCallback() {
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
  
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
  
      this.textInputLowerBound.addEventListener("change", (event) => {
        const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        event.target.value = newValue;
        this.rangeLowerBound.value = newValue;
        this.updateRangeStyles();
      });
  
      this.textInputHigherBound.addEventListener("change", (event) => {
        const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        event.target.value = newValue;
        this.rangeHigherBound.value = newValue;
        this.updateRangeStyles();
      });
  
      this.rangeLowerBound.addEventListener("change", (event) => {
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeHigherBound.addEventListener("change", (event) => {
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeLowerBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        this.textInputLowerBound.value = event.target.value;
        this.updateRangeStyles();
      });
  
      this.rangeHigherBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        this.textInputHigherBound.value = event.target.value;
        this.updateRangeStyles();
      });
    }
  
    updateRangeStyles() {
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
    }
  }

  window.customElements.define("price-range1", PriceRange1);


/* ========================================
   PRODUCT GALLERY — Vanilla JS (no Flickity)
   Swipe on mobile, click thumbnails, arrow keys
   ======================================== */

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const gallery = document.querySelector('.product-single__gallery');
    if (!gallery) return;

    const slides = Array.from(gallery.querySelectorAll('.product-single__gallery-item'));
    const thumbList = document.querySelector('.product-single__thumbnails');
    const thumbs = thumbList ? Array.from(thumbList.querySelectorAll('.product-single__thumbnails-item')) : [];
    let currentIndex = 0;

    // --- Core: go to slide ---
    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach(function(s, i) {
        s.classList.remove('is-active', 'is-selected');
        if (i === index) {
          s.classList.add('is-active', 'is-selected');
        }
      });

      thumbs.forEach(function(t, i) {
        t.classList.remove('active');
        if (i === index) {
          t.classList.add('active');
          // Scroll thumb into view
          t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });

      // Pause all videos, play current if video
      slides.forEach(function(s) {
        var v = s.querySelector('video');
        if (v) { v.pause(); }
      });
      var currentVideo = slides[index].querySelector('video');
      if (currentVideo) {
        currentVideo.currentTime = 0;
        currentVideo.play().catch(function(){});
      }

      currentIndex = index;
    }

    // --- Thumbnail clicks ---
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        goTo(i);
      });
    });

    // --- Arrow buttons (prev/next injected by CSS/HTML) ---
    var wrapper = gallery.closest('.product-single__media-group__wrap') || gallery.closest('.product-single__wrapper');
    if (wrapper) {
      // Create prev/next buttons
      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'gallery-arrow gallery-arrow--prev';
      prevBtn.setAttribute('aria-label', 'Previous');
      prevBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'gallery-arrow gallery-arrow--next';
      nextBtn.setAttribute('aria-label', 'Next');
      nextBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var galleryWrapper = gallery.closest('.product-single__wrapper');
      if (galleryWrapper) {
        galleryWrapper.style.position = 'relative';
        galleryWrapper.appendChild(prevBtn);
        galleryWrapper.appendChild(nextBtn);
      }

      prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
      nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });
    }

    // --- Swipe support (touch) ---
    var touchStartX = 0;
    var touchEndX = 0;
    var touchStartY = 0;
    var touchEndY = 0;

    gallery.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    gallery.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      var diffX = touchStartX - touchEndX;
      var diffY = Math.abs(touchStartY - touchEndY);
      // Only trigger if horizontal swipe > 50px and more horizontal than vertical
      if (Math.abs(diffX) > 50 && Math.abs(diffX) > diffY) {
        if (diffX > 0) {
          goTo(currentIndex + 1); // swipe left = next
        } else {
          goTo(currentIndex - 1); // swipe right = prev
        }
      }
    }, { passive: true });

    // --- Keyboard support ---
    document.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowRight') goTo(currentIndex + 1);
      if (e.key === 'ArrowLeft') goTo(currentIndex - 1);
    });

    // --- Init: select first or variant featured media ---
    var initialIndex = 0;
    var scriptTag = document.querySelector('script[data-selected-variant]');
    if (scriptTag) {
      try {
        var jsonData = JSON.parse(scriptTag.textContent.trim());
        var featuredMediaId = jsonData.featured_media && jsonData.featured_media.id;
        var sectionIdInput = document.querySelector('input[name="section-id"]');
        if (featuredMediaId && sectionIdInput) {
          var mediaId = sectionIdInput.value + '-' + featuredMediaId;
          slides.forEach(function(s, i) {
            if (s.id === mediaId || s.getAttribute('data-media-id') === mediaId) {
              initialIndex = i;
            }
          });
        }
      } catch(err) {}
    }
    goTo(initialIndex);
  });
})();
